import React, { Component } from 'react';
import { object, func } from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import convertGroupsToMenuItems from './convertGroupsToMenuItems';

// import LogOutButton from 'components/LogOutButton/LogOutButton';
import NestedList from 'components/NestedList/NestedList';
import Logo from './keencorp-logo.svg';

const Container = styled('div')`
  flex: 0 0 20rem;
  max-width: 20rem;
  padding: 2em 2em 6em;
  background-color: #F8F9FC;
`;

const StyledLogo = styled(Logo)`
  width: 100%;
  padding: 1em;
  margin-top: -1.66em;
  margin-bottom: 2.65em;
  padding-bottom: 0;
  background-color: ${({ theme }) => theme.base.Teal};
`;

const HomeLink = styled(Link)`
  display: block;
  text-align: center;
  background-color: white;
  margin-left: -2em;
  margin-top: -2em;
  margin-right: -2em;
  padding-bottom: 1.65em;
  border-bottom: 1px solid #E1E8EF;
`;

class Sidebar extends Component {
  render() {
    const { menuData, onChangeActiveGroups } = this.props;
    if (!menuData) return null;

    const items = convertGroupsToMenuItems(menuData);

    return (
      <Container>
        <HomeLink to="/">
          <StyledLogo />
        </HomeLink>
        {items && (
          <NestedList
            menuItems={items}
            onChangeActiveGroups={onChangeActiveGroups}
          />
        )}
      </Container>
    );
  }
}

NestedList.propTypes = {
  onChangeActiveGroups: func.isRequired,
  menuData: object,
};

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js